// Pure helpers for the PlaylistStrip (PRD §9.5, B2 PR6 / B2f).
//
// Lives in its own file so PlaylistStrip.tsx contains only the
// component exports — keeps Vite's react-refresh happy and lets the
// thumbnail-picking rule be unit-tested without rendering React.

import type { components } from '../api/schema';

type CandidateOut = components['schemas']['CandidateOut'];
type AssetOut = components['schemas']['AssetOut'];

/**
 * Pick the first still-image asset on a candidate. The publish path
 * stamps a thumbnail still for each candidate when the source is a video;
 * for image-source candidates the source itself is the thumb. Falls
 * back to `null` when neither is available — the tile then renders
 * label-only.
 *
 * `undefined` input (e.g. candidate query still pending) returns null
 * so the caller can use it directly in render without an extra guard.
 */
export function pickThumbnailAsset(
  candidate: CandidateOut | undefined
): AssetOut | null {
  if (candidate === undefined) return null;
  const assets = candidate.assets ?? [];
  const still = assets.find((a) => a.mime_type.startsWith('image/'));
  return still ?? null;
}
